// extracted by mini-css-extract-plugin
export var stepActive = "_1s-3";
export var stepCompleted = "_1s-4";
export var stepConnectorLine = "_1s-b";
export var stepIndicatorCircle = "_1s-6";
export var stepIndicatorCircleCompleted = "_1s-7";
export var stepIndicatorCircleDefault = "_1s-8";
export var stepIndicatorTextCompleted = "_1s-9";
export var stepIndicatorTextDefault = "_1s-a";
export var stepPending = "_1s-5";
export var wizardContainer = "_1s-1";
export var wizardContent = "_1s-2";
export var wizardModal = "_1s-0";